import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import printer from "@/assets/images/svg/printer.svg";
import { toggleModalVisible } from "@/utils/vue-helpers/modal";
import BookingModule from "@/store/modules/booking";
import { TicketTypes } from "@/interfaces/receipts";
import PrinterConfigModule from "@/store/modules/printers-config";
import { LogLevel, LogService } from "@/services/logging";
import { printTicketsNative, printLabels, printBookingReceipt, printTicketsThruPrintNode } from "@/utils/vue-helpers/booking";
import POSConfigModule from "@/store/modules/pos-config";
import { syncAvailabilities } from "@/db/product-slot-booking";
export default defineComponent({
  name: ModalComponents.PrintTicketsAndReceipt,
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var iconStyle, iconContent, iconAlt, _useI18n, t, vats, loadingBookingInfo, modalVisible, showPrintLabelButton, showPrintTicketButton, printTicketLoading, closeModal, componentPrintReceipt, _componentPrintReceipt, printTickets, _printTickets, printTickets2, _printTickets2, printAll, _printAll;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _printAll = function _printAll3() {
                _printAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          componentPrintReceipt();

                          if (PrinterConfigModule.isTicketPrintingEnabled) {
                            printTickets2();
                          }

                          if (PrinterConfigModule.isLabelPrintingEnabled) {
                            printLabels();
                          }

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
                return _printAll.apply(this, arguments);
              };

              printAll = function _printAll2() {
                return _printAll.apply(this, arguments);
              };

              _printTickets2 = function _printTickets6() {
                _printTickets2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var ticketType;
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          printTicketLoading.value = true;
                          _context4.prev = 1;

                          if (!POSConfigModule.isVHS) {
                            _context4.next = 6;
                            break;
                          }

                          _context4.next = 5;
                          return printTicketsNative();

                        case 5:
                          return _context4.abrupt("return");

                        case 6:
                          // check if we need to print mini-tickets or regular tickets (based on the POS settings)
                          ticketType = PrinterConfigModule.ticketType;

                          if (!(ticketType === TicketTypes.MiniTicket)) {
                            _context4.next = 12;
                            break;
                          }

                          _context4.next = 10;
                          return printTicketsNative();

                        case 10:
                          _context4.next = 14;
                          break;

                        case 12:
                          _context4.next = 14;
                          return printTickets();

                        case 14:
                          _context4.next = 19;
                          break;

                        case 16:
                          _context4.prev = 16;
                          _context4.t0 = _context4["catch"](1);
                          LogService.info("Ticket Printing: Error when printing ticket", _context4.t0, LogLevel.Error);

                        case 19:
                          _context4.prev = 19;
                          printTicketLoading.value = false;
                          return _context4.finish(19);

                        case 22:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[1, 16, 19, 22]]);
                }));
                return _printTickets2.apply(this, arguments);
              };

              printTickets2 = function _printTickets5() {
                return _printTickets2.apply(this, arguments);
              };

              _printTickets = function _printTickets4() {
                _printTickets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var groupId, selectedBooking;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return printTicketsThruPrintNode();

                        case 2:
                          // Explicitly pull availabilities for this booking if groupId=X
                          groupId = POSConfigModule.groupId; // 16342: Test
                          // 16383: Dev
                          // X: Prod

                          if (groupId && [1, 16342, 16383, 15484].includes(groupId)) {
                            selectedBooking = BookingModule.selectedBooking;

                            if (selectedBooking) {
                              // sync availabilities without awaiting
                              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.prev = 0;
                                        LogService.info("Pulling availabilities for booking ".concat(selectedBooking.uuid, " after printing the ticket"));
                                        _context2.next = 4;
                                        return syncAvailabilities([selectedBooking]);

                                      case 4:
                                        _context2.next = 9;
                                        break;

                                      case 6:
                                        _context2.prev = 6;
                                        _context2.t0 = _context2["catch"](0);
                                        LogService.info("Error when pulling availabilities after printing booking: ".concat(selectedBooking.uuid), _context2.t0, LogLevel.Error);

                                      case 9:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, null, [[0, 6]]);
                              })));
                            }
                          }

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _printTickets.apply(this, arguments);
              };

              printTickets = function _printTickets3() {
                return _printTickets.apply(this, arguments);
              };

              _componentPrintReceipt = function _componentPrintReceip2() {
                _componentPrintReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          printBookingReceipt();

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _componentPrintReceipt.apply(this, arguments);
              };

              componentPrintReceipt = function _componentPrintReceip() {
                return _componentPrintReceipt.apply(this, arguments);
              };

              iconStyle = "width: 20px; height: 27px;";
              iconContent = printer;
              iconAlt = "printer";
              _useI18n = useI18n({}), t = _useI18n.t;
              vats = ref([]);
              loadingBookingInfo = ref(false);
              modalVisible = dialogVisibleForStatus(ModalStatus.PrintTicketsAndReceipt);
              showPrintLabelButton = computed(function () {
                return PrinterConfigModule.isLabelPrintingEnabled;
              });
              showPrintTicketButton = computed(function () {
                return PrinterConfigModule.isTicketPrintingEnabled;
              });
              printTicketLoading = ref(false);

              closeModal = function closeModal() {
                toggleModalVisible(ModalStatus.Hidden);
              };

              return _context6.abrupt("return", {
                modalVisible: modalVisible,
                iconStyle: iconStyle,
                iconContent: iconContent,
                iconAlt: iconAlt,
                t: t,
                closeModal: closeModal,
                componentPrintReceipt: componentPrintReceipt,
                printTickets: printTickets,
                printTickets2: printTickets2,
                loadingBookingInfo: loadingBookingInfo,
                vats: vats,
                printLabels: printLabels,
                showPrintLabelButton: showPrintLabelButton,
                showPrintTicketButton: showPrintTicketButton,
                printAll: printAll,
                printTicketLoading: printTicketLoading
              });

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
});